import { render, staticRenderFns } from "./FretePorTransportadora.vue?vue&type=template&id=05dd58ea"
import script from "./FretePorTransportadora.vue?vue&type=script&lang=js"
export * from "./FretePorTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports